import React from 'react';
import { tp } from 'app/utils/typograf';
import classNames from 'classnames';
import { firstCards } from './cards.record';
import css from './halloweenDetails.module.scss';
import offerBannerPath from './img/harryBoxBanner.jpg';


const HarryOfferCompoent = () => (
    <div className={css.helloweenOfferRoot}>
        <div className="">
            <div className={css.helloweenOfferImgWrapper}>
                <img src={offerBannerPath} alt="offer" className={css.helloweenOfferImg} />
            </div>
            <div className={css.halloweenDetailsTitle}>
                Бокс “Вкусный тур в Хогвартс” 4 240 ₽
            </div>
            <div className={css.classNamehelloweenOfferContent}>
                <div className={css.helloweenOfferText}>
                    Вас ждёт кулинарный экспириенс на целый вечер! Сова доставит вам прямо к двери:
                </div>
                <div className={css.helloweenOfferList}>
                    <div className={css.helloweenOfferText}>
                        Наборы с ингредиентами
                        <br />
                        в нужных пропорциях
                    </div>
                    <div className={css.helloweenOfferText}>
                        Всё необходимое
                        <br />
                        для декора
                    </div>
                    <div className={css.helloweenOfferText}>
                        Пошаговые рецепты
                        <br />
                        с заклинаниями
                    </div>
                </div>
                <div className={css.helloweenOfferText}>
                    Зовите друзей, близких и детей, чтобы вместе приготовить и попробовать сладости из Вселенной Гарри Поттера.
                </div>
            </div>
            <div className={classNames(css.helloweenOfferText, css.bold)}>
                Доставка бесплатно
            </div>
        </div>
    </div>
);

const HarryDishCardForDetail = ({
    title,
    desc,
    img,
}) => (
    <div className={css.halloweenDishCardRoot}>
        <div className={css.halloweenDishCardImg}>
            <img src={img} alt="" className={css.halloweenDishCardImgItem} />
        </div>
        <div className={css.halloweenDishCardTitle}>{title}</div>
        <div className={css.halloweenDishCardDesc}>{desc}</div>
    </div>
);

// NOTE: Деталка Harry
export const HarryDetails = (props) => {
    const { id } = props;

    const dishDetailsTitleClasses = classNames({
        [css.halloweenDetailsTitle]: true,
        [css.smallMargin]: true,
    });

    return (
        <div className={css.halloweenDetailsRoot}>
            {/* <HarryInfo /> */}
            <div className={dishDetailsTitleClasses}>
                {tp.execute('Всё, чтобы перенестись во Вселенную Гарри Поттера')}
            </div>
            <div className={css.halloweenDetailsDescription}>
                {tp.execute('Волшебные сладости, закуски и напитки из Хогвартса! Приготовите за 1,5 часа, хватит на 6–8 человек')}
            </div>
            <div className={css.halloweenDetailsTitle}>
                Маршрут вечера:
            </div>
            {/*  */}
            <div className={css.halloweenDetailsList}>
                {firstCards.map((itm) => <HarryDishCardForDetail {...itm} />)}
            </div>
            <HarryOfferCompoent />
        </div>
    );
};
